import { render, staticRenderFns } from "./SalonInfoReview.vue?vue&type=template&id=5c18c992&scoped=true"
import script from "./SalonInfoReview.vue?vue&type=script&lang=js"
export * from "./SalonInfoReview.vue?vue&type=script&lang=js"
import style0 from "./SalonInfoReview.vue?vue&type=style&index=0&id=5c18c992&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c18c992",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VCard,VCardText,VContainer,VProgressCircular})
